import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const defaultPortalContext = typeof document === 'undefined' ? null : document.body;
const rootLayoutContext = createContext(defaultPortalContext);
export function useRootLayoutContext() {
    const context = useContext(rootLayoutContext);
    return context;
}
export function RootLayoutProvider(props) {
    return (_jsx(rootLayoutContext.Provider, { value: props.innerRef, children: props.children }));
}
//# sourceMappingURL=RootLayoutContext.js.map